var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',_vm._b({attrs:{"type":"button","variant":_vm.variant,"disabled":_vm.disabled},on:{"click":function($event){return _vm.bus.$emit('reset')}}},'b-button',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.resetText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }